if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.isZoomed = false;
			this.zoomFactor = 2;

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

			this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');

				this.image.removeEventListener('click', this._onImageClickBinded);
				this._onImageClickBinded = this._onImageClick.bind(this);
				this.image.addEventListener('click', this._onImageClickBinded);

				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this), { once:true });
				}
			});
			this.figureImageElementParent = this.closest(".product-gallery-item");
			if(this.figureImageElementParent) {
				this.figureImageElement = this.figureImageElementParent.querySelector('figure');
				if(this.figureImageElement) {
					this.figureImageElement.addEventListener('click', (e)=>{
						this.zoom.classList.add('opened');
						this.image = this.zoom.querySelector('img');
						this.image.src = this.getAttribute('data-image');

						this.image.removeEventListener('click', this._onImageClickBinded);
						this._onImageClickBinded = this._onImageClick.bind(this);
						this.image.addEventListener('click', this._onImageClickBinded);

						if ( this.image.naturalWidth > 0 ) {
							this._productZoomMount();
						} else {
							this.image.addEventListener('load', this._productZoomMount.bind(this), { once:true });
						}						
					})
				}
			}

		}

		_onImageClick(e){
			if (!this.zoom.classList.contains('loaded')) return;
			if (window.innerWidth <= 768) return;

			window.clientX = e.clientX;
			window.clientY = e.clientY;

			this.isZoomed = !this.isZoomed;

			if (this.isZoomed) {
				window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, { passive:true });
			} else {
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
			}

			this.onResizeHandler();
			this.zoom.classList.toggle('zoomed-in', this.isZoomed);
			e.stopPropagation();
		}

		onMouseMoveHandler(e){
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		onResizeHandler(){
			const nw = this.image.naturalWidth;
			const nh = this.image.naturalHeight;
			if (!nw || !nh) return;

			const base = Math.min(window.innerWidth / nw, window.innerHeight / nh, 1);
			const scale = Math.min(base * (this.isZoomed ? this.zoomFactor : 1), 1);

			const w = Math.round(nw * scale);
			const h = Math.round(nh * scale);

			this.image.style.width = w + 'px';
			this.image.style.height = h + 'px';

			if (!this.isZoomed) {
				this.image.style.left = Math.round((window.innerWidth - w) / 2) + 'px';
				this.image.style.top  = Math.round((window.innerHeight - h) / 2) + 'px';
			} else {
				const cx = (typeof window.clientX === 'number') ? window.clientX : window.innerWidth / 2;
				const cy = (typeof window.clientY === 'number') ? window.clientY : window.innerHeight / 2;
				const x = cx * ( window.innerWidth - w ) / window.innerWidth;
				const y = cy * ( window.innerHeight - h ) / window.innerHeight;
				this.image.style.left = x + 'px';
				this.image.style.top  = y + 'px';
			}
		}

		_productZoomMount(image) {
			this.isZoomed = false;
			this.image.style.left = 0;
			this.image.style.top = 0;

			window.clientX = window.innerWidth / 2;
			window.clientY = window.innerHeight / 2;

			// window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			// window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
			}, 50);
		}

		_productZoomUnmount() {
			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.isZoomed = false;
				this.zoom.classList.remove('loaded','zoomed-in');
			}, 300);
		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}
}
